{
  "propertyManager": "Disponent",
  "propertyMaintenance": "Fastighetsskötsel",
  "propertySecretary": "Fastighetssekreterare",
  "customerService": "Kundservice",
  "residentsCommittee": "Boendekommitté",
  "contactInformation": "Kontaktinformation",
  "contactMaintenanceOrManager": "Ska jag kontakta disponenten eller fastighetsskötseln?",
  "callLabel": {
    "withName": "Ring {{name}}, {{phoneNumber}}",
    "withoutName": "Ring {{phoneNumber}}"
  },
  "emailLabel": {
    "withName": "Skicka e-post till {{name}}, {{email}}",
    "withoutName": "Skicka e-post till {{email}}"
  },
  "errors": {
    "title": "Fel",
    "failedToLoadContacts": "Det uppstod ett fel vid laddning av kontaktinformation. Försök igen senare."
  },
  "democracyRoles": {
    "chairperson": "Ordförande",
    "vice_chairperson": "Vice ordförande",
    "member": "Medlem",
    "treasurer": "Kassör",
    "secretary": "Sekreterare",
    "contact_person": "Kontaktperson",
    "representative": "Representant",
    "board_member": "Styrelsemedlem",
    "supervisor": "Övervakare"
  },
  "legal": {
    "privacyStatementLinkText": "Dataskyddsbeskrivning",
    "accessibilityStatementLinkText": "Tillgänglighetsutlåtande",
    "termsOfUseLinkText": "Användarvillkor",
    "privacyStatementLink": "https://mikalo.fi/evastekaytanto-eu/",
    "accessibilityStatementLink": "https://mikalo.fi/tietoa-meista/saavutettavuusseloste/",
    "termsOfUseLink": "https://mikalo.fi/evastekaytanto-eu/"
  },
  "question": {
    "title": "Fråga om boende",
    "description": "Använd detta formulär för att fråga oss om bostadsrelaterade ärenden. Vi strävar efter att svara inom några dagar.",
    "button": "Fråga om boende"
  },
  "feedback": {
    "title": "Ge feedback",
    "description": "Med detta formulär kan du ge feedback till bostadsbolaget eller underhållsbolaget. Vi återkommer till saken vid behov inom cirka 10 arbetsdagar.",
    "button": "Ge feedback"
  }
}